import LateswapCsvPlayerInterface from './lateswap-csv-player-interface';

class LateswapCsvPlayer implements LateswapCsvPlayerInterface {
    constructor(
        private externalId: string,
        private positionInLineup: string,
        private player: object,
    ) {}

    getExternalId(): string {
        return this.externalId;
    }

    getLineupPosition(): string {
        return this.positionInLineup;
    }

    getPlayer(): object {
        return this.player;
    }
}

export default LateswapCsvPlayer;
